module.exports = __webpack_public_path__ + "img/Odometer.57616678.jpg";